(() => {
  // Locale lookup. Strings come from locales/*.json via snippets/tsv-i18n-search.liquid.
  const T = (key, fallback) => (window.TSV_T && window.TSV_T[key]) || fallback;

  // ====== REQUIRED ELEMENTS (same as original) ======
  const panel = document.getElementById('tsv-search-panel');
  if (!panel) return;

  const overlay =
    panel.closest('[data-tsv-search-overlay]') ||
    panel.closest('[data-tsv-search-root]') ||
    document;

  const scrim =
    document.querySelector('.tsv-search-scrim') ||
    overlay.querySelector('.tsv-search-scrim');

  const inputDesktop = document.querySelector('[data-tsv-search-input-desktop]');
  const inputMobile  = document.querySelector('[data-tsv-search-input-mobile]');

  const productsEl    = overlay.querySelector('[data-tsv-products]');
  const brandsEl      = overlay.querySelector('[data-tsv-brands]');
  const notesEl       = overlay.querySelector('[data-tsv-notes]');
  const collectionsEl = overlay.querySelector('[data-tsv-collections]');

  const emptyEl      = overlay.querySelector('[data-tsv-empty]');
  const viewAllWrap  = overlay.querySelector('[data-tsv-viewall]');
  const viewAllLink  = overlay.querySelector('[data-tsv-viewall-link]');
  const viewAllTerm  = overlay.querySelector('[data-tsv-viewall-term]');

  // TSV: in-dropdown "no matches" rescue panel — shown when a typed query
  // returns zero hits across products, brands, collections, families, notes.
  const noHitsEl       = overlay.querySelector('[data-tsv-no-hits]');
  const noHitsTermEl   = overlay.querySelector('[data-tsv-no-hits-term]');
  const noHitsFullLink = overlay.querySelector('[data-tsv-no-hits-full]');
  const noHitsFullTerm = overlay.querySelector('[data-tsv-no-hits-full-term]');

  if (!productsEl || !brandsEl || !collectionsEl) return;

  // ====== SETTINGS ======
  const MIN_CHARS = 2;
  const MAX_PRODUCTS = 4;
  const MAX_BRANDS = 4;
  const MAX_COLLECTIONS = 3;
  const MAX_FAMILIES = 4;
  const MAX_NOTES = 5;

  // ====== FRAGRANCE FAMILIES ======
  const FAMILIES = {
    'Citrus':'family_citrus','Aquatic':'family_aquatic','Green':'family_green',
    'Aromatic':'family_aromatic','Fougère':'family_fougere','Floral':'family_floral',
    'White Floral':'family_white-floral','Powdery':'family_powdery','Fruity':'family_fruity',
    'Amber':'family_amber','Oriental':'family_oriental','Spicy':'family_spicy',
    'Warm Spicy':'family_warm-spicy','Gourmand':'family_gourmand','Sweet':'family_sweet',
    'Balsamic':'family_balsamic','Woody':'family_woody','Smoky':'family_smoky',
    'Leather':'family_leather','Earthy':'family_earthy','Oud':'family_oud',
    'Chypre':'family_chypre','Musk':'family_musk','Herbal':'family_herbal',
    'Vanillic':'family_vanillic','Marine':'family_marine','Tropical':'family_tropical',
    'Aldehydic':'family_aldehydic','Fresh':'family_fresh','Animalic':'family_animalic',
    'Resinous':'family_resinous','Creamy Woody':'family_creamy-woody','Dry Woody':'family_dry-woody'
  };

  // Family display labels. The FAMILIES keys stay in English because they are the
  // collection handles' source of truth; this maps them to locale keys for display
  // and lets the matcher accept the translated word as well.
  const FAMILY_KEYS = {
    'Citrus':'fam_citrus','Aquatic':'fam_aquatic','Green':'fam_green','Aromatic':'fam_aromatic',
    'Fougère':'es_fougere','Floral':'fam_floral','White Floral':'fam_white_floral',
    'Powdery':'fam_powdery','Fruity':'fam_fruity','Amber':'fam_amber','Oriental':'es_oriental',
    'Spicy':'fam_spicy','Warm Spicy':'fam_warm_spicy','Gourmand':'fam_gourmand','Sweet':'fam_sweet',
    'Balsamic':'fam_balsamic','Woody':'fam_woody','Smoky':'fam_smoky','Leather':'fam_leather',
    'Earthy':'fam_earthy','Oud':'fam_oud','Chypre':'gd_082','Musk':'fam_musk','Herbal':'fam_herbal',
    'Vanillic':'fam_vanillic','Marine':'fam_marine','Tropical':'fam_tropical',
    'Aldehydic':'fam_aldehydic','Fresh':'fam_fresh','Animalic':'gd_198','Resinous':'fam_resinous',
    'Creamy Woody':'fam_creamy_woody','Dry Woody':'fam_dry_woody'
  };
  const famLabel = (name) => T(FAMILY_KEYS[name] || '', name);

  // ====== NOTES ======
  const NOTES = [
    'Amber','Ambergris','Amberwood','Ambroxan','Aldehydes','Almond','Anise',
    'Apple','Apricot','Basil','Benzoin','Bergamot','Bitter Orange','Black Pepper',
    'Black Tea','Blackberry','Blackcurrant','Blueberry','Brown Sugar','Bulgarian Rose',
    'Caramel','Cardamom','Carnation','Cashmeran','Cedarwood','Chamomile','Cherry',
    'Cinnamon','Citron','Citrus Accord','Clary Sage','Clove','Cocoa','Coconut',
    'Coffee','Coriander','Cotton Candy','Cumin','Cypress','Dragon Fruit','Elemi',
    'Fig','Frangipani','Freesia','Gardenia','Geranium','Ginger','Grapefruit',
    'Green Apple','Green Tea','Guaiac Wood','Hazelnut','Heliotrope','Honey',
    'Incense','Iris','Jasmine','Juniper','Juniper Berry','Labdanum','Lavender',
    'Leather','Lemon','Lilac','Lily','Lily-of-the-Valley','Lime','Lychee',
    'Magnolia','Mandarin Orange','Mango','Melon','Mint','Musk','Myrrh','Neroli',
    'Nutmeg','Oakmoss','Opoponax','Orange','Orange Blossom','Orchid','Oregano',
    'Orris','Osmanthus','Ozone Notes','Passion Fruit','Patchouli','Peach','Pear',
    'Peony','Petitgrain','Pine','Pineapple','Pink Pepper','Plum','Pomegranate',
    'Praline','Raspberry','Red Peony','Rose','Rosemary','Saffron','Sage',
    'Sandalwood','Spearmint','Star Anise','Strawberry','Suede','Tangerine',
    'Tarragon','Tea','Thyme','Tobacco','Tonka Bean','Tuberose','Vanilla',
    'Vetiver','Violet','Violet Leaf','Watermelon','White Musk','Woody Notes',
    'Ylang-Ylang','Yuzu'
  ];

  // ====== TITLE SPLITTING ======
  const CONC_MAP = {
    'edp':'Eau de Parfum','edt':'Eau de Toilette','edc':'Eau de Cologne',
    'eds':'Eau de Senteur','parfum':'Parfum','elixir':'Elixir',
    'extrait':'Extrait','cologne':'Cologne'
  };
  const CONC_RE = /\b(Eau\s+de\s+Parfum(?:\s+Intense|\s+Fra[iî]che)?|Eau\s+de\s+Toilette(?:\s+Intense)?|Eau\s+de\s+Cologne|Eau\s+de\s+Senteur|Eau\s+Fra[iî]che|Extrait\s+de\s+Parfum|EDP|EDT|EDC|EDS|Parfum|Elixir|Extrait|Cologne)\b(?=(?:\s*(?:limited\s+edition|\(?\s*\d+(?:\.\d+)?\s*(?:[x×]\s*\d+(?:\.\d+)?\s*)?ml\s*\)?|\+\s*\d+(?:\.\d+)?\s*[x×]\s*\d+(?:\.\d+)?\s*ml|(?:gift|discovery|travel)\s+set|duo|set))*\s*$)/i;
  const SIZE_RE = /\(?\s*(\d+(?:\.\d+)?(?:\s*[x×]\s*\d+(?:\.\d+)?)?)\s*ml\b\s*\)?/i;
  const TYPE_RE = /\b(Deodorant\s+Stick|Deodorant\s+Spray|Deodorant|Roll[- ]?On|Bath\s*&\s*Shower\s+Gel|Shower\s+Gel|Shower\s+Cream|Bath\s+Gel|Body\s+Lotion|Body\s+Cream|Body\s+Butter|Body\s+Spray|Body\s+Wash|Body\s+Oil|Hair\s*&\s*Body\s+Mist|Body\s+Mist|Hair\s+Mist|Hand\s+Cream|After\s*shave\s+Balm|After\s*shave\s+Lotion|After\s*shave|Gift\s+Set|Discovery\s+Set|Travel\s+Set|Duo|Beard\s+Oil|Lotion|Soap|Candle)\b/i;

  function splitTitle(t) {
    if (!t) return { name: '', subtitle: '' };
    const cm = t.match(CONC_RE), tm = t.match(TYPE_RE);
    let n = t; const p = [];
    if (cm) {
      n = t.slice(0, cm.index).replace(/[\s,·\-–]+$/, '').trim();
      const r = t.slice(cm.index + cm[0].length).trim();
      p.push(CONC_MAP[cm[1].toLowerCase()] || cm[1]);
      const s = r.match(SIZE_RE) || t.match(SIZE_RE);
      if (s) p.push(s[1] + 'ml');
      const ti = r.match(TYPE_RE);
      if (ti) p.push(ti[1]); else if (tm && tm.index > cm.index) p.push(tm[1]);
      if (!n) { n = t; p.length = 0; }
    } else if (tm) {
      n = t.slice(0, tm.index).replace(/[\s,·\-–]+$/, '').trim();
      p.push(tm[1]); const s = t.match(SIZE_RE); if (s) p.push(s[1] + 'ml');
      if (!n) { n = t; p.length = 0; }
    } else {
      const s = t.match(SIZE_RE);
      if (s) { n = t.replace(SIZE_RE, '').replace(/[\s,·\-–]+$/, '').trim(); p.push(s[1] + 'ml'); }
    }
    return { name: n || t, subtitle: p.join(' \u00b7 ') };
  }

  // ====== STATE ======
  let open = false;
  let lastQuery = '';
  let aborter = null;
  let familiesSection = null;
  let notesSection = null;

  // ====== HELPERS ======
  const isWide = () => window.matchMedia('(min-width: 750px)').matches;

  let savedScrollY = 0;
  const isIosChromeFix = () => document.documentElement.classList.contains('tsv-ios-fix');

  const lockScroll = () => {
    savedScrollY = isIosChromeFix() ? document.body.scrollTop : window.scrollY;
    document.documentElement.classList.add('tsv-lock');
    document.body.classList.add('tsv-lock');

    if (!isIosChromeFix() && !isWide()) {
      document.body.style.position = 'fixed';
      document.body.style.top = `-${savedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
    }
  };
  const unlockScroll = () => {
    document.documentElement.classList.remove('tsv-lock');
    document.body.classList.remove('tsv-lock');

    if (isIosChromeFix()) {
      document.body.scrollTop = savedScrollY;
    } else if (document.body.style.position === 'fixed') {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, savedScrollY);
    }

    /* iOS keyboard close fix: force viewport recalculation */
    setTimeout(function() {
      window.scrollTo(0, window.scrollY);
      if (window.visualViewport) {
        document.documentElement.style.height = '100%';
        requestAnimationFrame(function() {
          document.documentElement.style.height = '';
        });
      }
    }, 100);
  };

  function getAnchorForActive() {
    const active = document.activeElement;
    return (
      (active && active.closest && active.closest('[data-tsv-anchor]')) ||
      (inputDesktop && inputDesktop.closest('[data-tsv-anchor]')) ||
      (inputMobile && inputMobile.closest('[data-tsv-anchor]')) ||
      document.querySelector('[data-tsv-anchor]')
    );
  }

  function getGhostForInput(input) {
    if (!input) return null;
    const field = input.closest('[data-tsv-anchor]') || input.closest('.tsv-header-search__field');
    return field ? field.querySelector('[data-tsv-ghost]') : null;
  }

  function setScrimTop() {
    const anchor = getAnchorForActive();
    if (!anchor) {
      document.documentElement.style.setProperty('--tsv-scrim-top', '0px');
      return;
    }
    const r = anchor.getBoundingClientRect();
    document.documentElement.style.setProperty('--tsv-scrim-top', `${Math.round(r.bottom)}px`);
  }

  function positionPanel() {
    const anchor = getAnchorForActive();
    if (!anchor) return;

    const r = anchor.getBoundingClientRect();
    const top = Math.round(r.bottom);

    if (isWide()) {
      const left = Math.max(12, Math.round(r.left));
      const maxW = Math.min(900, window.innerWidth - left - 12);
      const w = Math.max(600, Math.min(maxW, window.innerWidth - 24));

      panel.style.left = `${left}px`;
      panel.style.top  = `${top}px`;
      panel.style.width = `${w}px`;
    } else {
      panel.style.left = `0px`;
      panel.style.top  = `${top}px`;
      panel.style.width = `100vw`;
      panel.style.bottom = `0px`;
      panel.style.maxHeight = 'none';
    }
  }

  function disableHeaderTransforms() {
    if (!isIosChromeFix()) return;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function(el) {
      el.style.transform = 'none';
      el.style.webkitTransform = 'none';
    });
  }
  function restoreHeaderTransforms() {
    if (!isIosChromeFix()) return;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function(el) {
      el.style.transform = '';
      el.style.webkitTransform = '';
    });
  }

  function openSearch() {
    if (open) return;
    open = true;
    disableHeaderTransforms();
    document.documentElement.classList.add('tsv-search-open');
    panel.setAttribute('aria-hidden', 'false');
    lockScroll();
    setScrimTop();
    positionPanel();
  }

  function closeSearch() {
    if (!open) return;
    open = false;
    document.documentElement.classList.remove('tsv-search-open');
    document.documentElement.classList.remove('tsv-search-focused');
    panel.setAttribute('aria-hidden', 'true');
    unlockScroll();
    restoreHeaderTransforms();
    if (aborter) aborter.abort();
  }

  // ====== CLOSE WIRING ======
  document.querySelectorAll('[data-tsv-search-close]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      closeSearch();
    });
  });

  if (scrim) {
    scrim.addEventListener('click', (e) => {
      e.preventDefault();
      document.documentElement.classList.remove('tsv-search-focused');
      if (open) closeSearch();
      else {
        unlockScroll();
        if (inputDesktop) inputDesktop.blur();
        if (inputMobile) inputMobile.blur();
      }
    });

    /* Prevent touch scrolling through the scrim on mobile */
    scrim.addEventListener('touchmove', function(e) {
      e.preventDefault();
    }, { passive: false });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });

  var _srRaf = 0;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(_srRaf);
    _srRaf = requestAnimationFrame(() => {
      if (open) { setScrimTop(); positionPanel(); }
    });
  });

  var _ssRaf = 0;
  window.addEventListener('scroll', () => {
    cancelAnimationFrame(_ssRaf);
    _ssRaf = requestAnimationFrame(() => {
      if (open && isWide()) { setScrimTop(); positionPanel(); }
    });
  }, { passive: true });

  document.addEventListener('click', (e) => {
    if (!open) return;
    if (panel.contains(e.target)) return;
    if (inputDesktop && (e.target === inputDesktop || inputDesktop.contains(e.target))) return;
    if (inputMobile  && (e.target === inputMobile  || inputMobile.contains(e.target))) return;
    closeSearch();
  });

  // ====== GHOST ANIMATION ======
  const phrases = ['Search The Scent Vault', 'Dior Sauvage', 'Woody Fragrances', 'Vanilla', 'Creed Aventus', 'Oud'];
  let ghostTimer = null, phraseIdx = 0, charIdx = 0, deleting = false;

  function ghostStop() {
    if (ghostTimer) clearTimeout(ghostTimer);
    ghostTimer = null;

    const gd = getGhostForInput(inputDesktop);
    const gm = getGhostForInput(inputMobile);
    if (gd) gd.textContent = '';
    if (gm) gm.textContent = '';
  }

  function ghostStartIfIdle() {
    const activeInput = isWide() ? inputDesktop : inputMobile;
    const ghost = getGhostForInput(activeInput);

    if (!activeInput || !ghost) return;
    if (document.activeElement === activeInput) return;
    if ((activeInput.value || '').trim().length) return;

    const tick = () => {
      const inputNow = isWide() ? inputDesktop : inputMobile;
      const ghostNow = getGhostForInput(inputNow);

      if (!inputNow || !ghostNow) return ghostStop();
      if (document.activeElement === inputNow) return ghostStop();
      if ((inputNow.value || '').trim().length) return ghostStop();

      const target = phrases[phraseIdx % phrases.length];

      if (!deleting) {
        charIdx++;
        ghostNow.textContent = target.slice(0, charIdx);
        if (charIdx >= target.length) {
          deleting = true;
          ghostTimer = setTimeout(tick, 700);
          return;
        }
      } else {
        charIdx--;
        ghostNow.textContent = target.slice(0, charIdx);
        if (charIdx <= 0) {
          deleting = false;
          phraseIdx++;
          ghostTimer = setTimeout(tick, 250);
          return;
        }
      }

      ghostTimer = setTimeout(tick, deleting ? 40 : 55);
    };

    ghostStop();
    charIdx = 0;
    deleting = false;
    ghostTimer = setTimeout(tick, 450);
  }

  // ====== MATCHING ======
  function matchFamilies(q) {
    const l = q.toLowerCase();
    return Object.entries(FAMILIES)
      .filter(([name]) => {
        const n = name.toLowerCase();
        const t = famLabel(name).toLowerCase();
        return n.includes(l) || l.includes(n) || t.includes(l) || l.includes(t);
      })
      .slice(0, MAX_FAMILIES)
      .map(([name, handle]) => [famLabel(name), handle]);
  }

  function matchNotes(q) {
    const l = q.toLowerCase();
    return NOTES.filter(n => { const nl = n.toLowerCase(); return nl.includes(l) || l.includes(nl); }).slice(0, MAX_NOTES);
  }

  // ====== RENDERING ======
  function productCard(p) {
    const img = (p?.featured_image?.url || p?.image || '').replace(/\\u0026/g,'&');
    const vendor = p?.vendor || p?.vendor_name || '';
    const url = (p?.url || '').replace(/\\u0026/g,'&');
    const { name, subtitle } = splitTitle(p?.title || '');

    // Show "from €X" for multi-size products (price range), matching the cards.
    const toNum = (v) => {
      if (typeof v === 'number') return v;
      const n = Number(String(v == null ? '' : v).replace(/[^0-9.]/g, ''));
      return Number.isFinite(n) ? n : null;
    };
    let price = '';
    const pmin = toNum(p?.price_min), pmax = toNum(p?.price_max), pval = toNum(p?.price);
    if (pmin != null && pmax != null && pmax > pmin + 0.001) price = `from €${pmin.toFixed(2)}`;
    else if (pval != null) price = `€${pval.toFixed(2)}`;
    else if (pmin != null) price = `€${pmin.toFixed(2)}`;

    return `
      <a class="tsv-card" href="${url}">
        <div class="tsv-card__img-wrap">
          <img class="tsv-card__img" src="${img}" alt="" loading="lazy">
        </div>
        <div class="tsv-card__info">
          <span class="tsv-card__brand">${vendor}</span>
          <span class="tsv-card__title">${name}</span>
          ${subtitle ? `<span class="tsv-card__subtitle">${subtitle}</span>` : ''}
        </div>
        <span class="tsv-card__price">${price}</span>
      </a>
    `;
  }

  function chipLink(text, href) {
    return `<a class="tsv-chip" href="${href}">${text}</a>`;
  }

  function resetLists() {
    productsEl.innerHTML = '';
    brandsEl.innerHTML = '';
    if (notesEl) notesEl.innerHTML = '';
    collectionsEl.innerHTML = '';
    if (familiesSection) familiesSection.hidden = true;
    if (notesSection) notesSection.hidden = true;
  }

  function setSectionVisible(listEl, show) {
    const section = listEl.closest('.tsv-section');
    if (section) section.hidden = !show;
  }

  function setEmptyState(q) {
    const hasQ = (q || '').trim().length >= MIN_CHARS;

    if (!hasQ) {
      resetLists();
      setSectionVisible(productsEl, false);
      setSectionVisible(brandsEl, false);
      if (notesEl) setSectionVisible(notesEl, false);
      setSectionVisible(collectionsEl, false);

      if (viewAllWrap) viewAllWrap.hidden = true;
      if (noHitsEl) noHitsEl.hidden = true;
      if (emptyEl) {
        emptyEl.style.display = '';
        emptyEl.textContent = T('msc_start_typing','Start typing to search.');
      }

      closeSearch();
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (noHitsEl) noHitsEl.hidden = true;
  }

  async function fetchSuggest(q) {
    const url =
      `/search/suggest.json?q=${encodeURIComponent(q)}` +
      `&resources[type]=product,collection` +
      `&resources[limit]=10`;

    aborter = new AbortController();
    const res = await fetch(url, { signal: aborter.signal, headers: { 'Accept': 'application/json' } });

    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error(`Suggest failed ${res.status}: ${text.slice(0, 200)}`);
    }
    return res.json();
  }

  function renderAll(q, data) {
    const r = data?.resources?.results || {};
    const allProducts = Array.isArray(r.products) ? r.products : [];
    const allCollections = Array.isArray(r.collections) ? r.collections : [];

    // Dedupe exact-handle repeats and show in-stock products first (predictive can
    // return the same product twice or surface fully out-of-stock items).
    const _seenH = {};
    const _uniq = [];
    allProducts.forEach(function (p) {
      const h = (p && (p.handle || p.url)) || '';
      if (h && _seenH[h]) return;
      if (h) _seenH[h] = 1;
      _uniq.push(p);
    });
    _uniq.sort(function (a, b) { return (a && a.available === false ? 1 : 0) - (b && b.available === false ? 1 : 0); });
    const products = _uniq.slice(0, MAX_PRODUCTS);
    productsEl.innerHTML = products.map(productCard).join('');
    setSectionVisible(productsEl, products.length > 0);

    const vendorsAll = Array.from(new Set(products.map(p => (p.vendor || '').trim()).filter(Boolean)));
    const vendors = vendorsAll.slice(0, MAX_BRANDS);
    const brandChips = vendors.map(v => chipLink(v, `/collections/vendors?q=${encodeURIComponent(v)}`)).join('');

    brandsEl.innerHTML = brandChips;
    setSectionVisible(brandsEl, brandChips.length > 0);

    const families = matchFamilies(q);
    if (families.length > 0) {
      if (!familiesSection) {
        familiesSection = document.createElement('div');
        familiesSection.className = 'tsv-section';
        familiesSection.innerHTML = '<h3 class="tsv-section__title">' + T('fragrance_families', 'Fragrance Families') + '</h3><div class="tsv-list" data-tsv-families></div>';
        var brandsSection = brandsEl.closest('.tsv-section');
        if (brandsSection) brandsSection.parentNode.insertBefore(familiesSection, brandsSection);
      }
      var familiesListEl = familiesSection.querySelector('[data-tsv-families]') || familiesSection.querySelector('.tsv-list');
      familiesListEl.innerHTML = families.map(([name, handle]) => chipLink(name, `/collections/${handle}`)).join('');
      familiesSection.hidden = false;
    } else if (familiesSection) {
      familiesSection.hidden = true;
    }

    const notes = matchNotes(q);
    if (notes.length > 0) {
      if (!notesSection) {
        notesSection = document.createElement('div');
        notesSection.className = 'tsv-section';
        notesSection.innerHTML = '<h3 class="tsv-section__title">Notes</h3><div class="tsv-list" data-tsv-notes></div>';
        var brandsSection2 = brandsEl.closest('.tsv-section');
        if (brandsSection2 && brandsSection2.nextSibling) {
          brandsSection2.parentNode.insertBefore(notesSection, brandsSection2.nextSibling);
        } else if (brandsSection2) {
          brandsSection2.parentNode.appendChild(notesSection);
        }
      }
      var notesListEl = notesSection.querySelector('[data-tsv-notes]') || notesSection.querySelector('.tsv-list');
      notesListEl.innerHTML = notes.map(n => chipLink(n, `/search?q=${encodeURIComponent(n)}&type=product`)).join('');
      notesSection.hidden = false;
    } else if (notesSection) {
      notesSection.hidden = true;
    }

    const collections = allCollections.slice(0, MAX_COLLECTIONS);
    const collChips = collections.map(c => chipLink(c.title, (c.url || '').replace(/\\u0026/g,'&'))).join('');
    collectionsEl.innerHTML = collChips;
    setSectionVisible(collectionsEl, collections.length > 0);

    // TSV: detect total-zero and show the in-dropdown rescue panel.
    // Total across every section — products, brands, families, notes, collections.
    const totalHits = products.length + vendors.length + families.length + notes.length + collections.length;
    if (totalHits === 0) {
      if (noHitsEl) {
        if (noHitsTermEl) noHitsTermEl.textContent = '"' + q + '"';
        if (noHitsFullTerm) noHitsFullTerm.textContent = '"' + q + '"';
        if (noHitsFullLink) noHitsFullLink.href = '/search?q=' + encodeURIComponent(q);
        noHitsEl.hidden = false;
      }
      if (viewAllWrap) viewAllWrap.hidden = true;
    } else {
      if (noHitsEl) noHitsEl.hidden = true;
      if (viewAllWrap) viewAllWrap.hidden = false;
      if (viewAllTerm) viewAllTerm.textContent = '"' + q + '"';
      if (viewAllLink) viewAllLink.href = '/search?q=' + encodeURIComponent(q);
    }
  }

  async function onQuery(q) {
    const term = (q || '').trim();
    lastQuery = term;

    setEmptyState(term);
    if (term.length < MIN_CHARS) return;

    openSearch();

    try {
      if (aborter) aborter.abort();
      const data = await fetchSuggest(term);
      if (term !== lastQuery) return;
      renderAll(term, data);
      setScrimTop();
      positionPanel();
    } catch (err) {
      if (err?.name === 'AbortError') return;

      resetLists();
      setSectionVisible(productsEl, false);
      setSectionVisible(brandsEl, false);
      if (notesEl) setSectionVisible(notesEl, false);
      setSectionVisible(collectionsEl, false);

      if (viewAllWrap) viewAllWrap.hidden = true;
      if (emptyEl) {
        emptyEl.style.display = '';
        emptyEl.textContent = T('msc_start_typing','Start typing to search.');
      }
    }
  }

  // ====== INPUT WIRING ======
  function wireInput(input) {
    if (!input) return;

    input.addEventListener('focus', () => {
      ghostStop();
      disableHeaderTransforms();
      setScrimTop();
      positionPanel();
      document.documentElement.classList.add('tsv-search-focused');

      const q = (input.value || '').trim();
      if (q.length >= MIN_CHARS) openSearch();
    });

    input.addEventListener('input', () => {
      const q = input.value;

      if (inputDesktop && input !== inputDesktop) inputDesktop.value = q;
      if (inputMobile  && input !== inputMobile)  inputMobile.value  = q;

      ghostStop();
      onQuery(q);
    });

    input.addEventListener('blur', () => {
      setTimeout(() => {
        ghostStartIfIdle();
        if (!open && document.activeElement !== inputDesktop && document.activeElement !== inputMobile) {
          document.documentElement.classList.remove('tsv-search-focused');
          restoreHeaderTransforms();
        }
      }, 150);
    });
  }

  wireInput(inputDesktop);
  wireInput(inputMobile);

  ghostStartIfIdle();
})();